var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSnooze = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  width: "1em",
  height: "1em",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#30a7de",
  className: "snooze_svg__fa-secondary",
  opacity: 0.4,
  d: "M160 32c0-17.7 14.3-32 32-32h96c12.1 0 23.2 6.8 28.6 17.7s4.3 23.8-3 33.5L256 128h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-12.1 0-23.2-6.8-28.6-17.7s-4.3-23.8 3-33.5L224 64h-32c-17.7 0-32-14.3-32-32zm128 224c0-17.7 14.3-32 32-32h96c12.1 0 23.2 6.8 28.6 17.7 2.3 4.5 3.4 9.4 3.4 14.3 0 6.8-2.2 13.6-6.4 19.2L384 352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-12.1 0-23.2-6.8-28.6-17.7s-4.3-23.8 3-33.5L352 288h-32c-17.7 0-32-14.3-32-32z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#30a7de",
  className: "snooze_svg__fa-primary",
  d: "M0 288c0-17.7 14.3-32 32-32h160c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 448H192c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L123.7 320H32c-17.7 0-32-14.3-32-32z"
})));
export default SvgSnooze;